// Central place to manage backend endpoints used by the UI
export const apiConfig = {
	// Base URL to your backend API (no trailing slash preferred)
	baseUrl: "https://prod-application-tools-gwdzegbkh2ddahc8.centralus-01.azurewebsites.net/api",
	// Path to the ConnectWise project tickets endpoint
	cwProjectTicketsPath: "/v1/cw_project_tickets",
	// Path pattern for individual project details (use getProjectUrl helper)
	cwProjectPath: "/v1/cw_projects",
    // Path for company configuration types
    cwConfigTypesPath: "/v1/cw_config_types",
	// Path for creating a configuration record
	cwConfigCreatePath: "/v1/cw_config",
    // Path for finance agreements
    cwFinanceAgreementsPath: "/v1/cw_finance_agreements",
    // Path base for attaching configuration to agreement
    cwAttachConfigAgreementPath: "/v1/cw_attach_config_agreements",
	// Path for procurement products
	cwProcurementProductsPath: "/v1/cw_procurement_products",
	// Path for scheduled resources (members) by object id
	cwScheduledResourcesPath: "/v1/cw_scheduled_resources",
};

// Build the full URL for fetching project tickets, including conditions
export function getProjectTicketsUrl(conditions) {
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	const url = new URL(`${base}${apiConfig.cwProjectTicketsPath}`);
	if (conditions) {
		url.searchParams.set("conditions", conditions);
	}
	return url.toString();
}

// Build URL for a single project by numeric id
export function getProjectUrl(projectId) {
	if (projectId === undefined || projectId === null || projectId === "") return "";
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	return `${base}${apiConfig.cwProjectPath}/${projectId}`;
}

// Build URL for configuration types with optional conditions
export function getConfigTypesUrl(conditions = "inactiveFlag=false") {
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	const url = new URL(`${base}${apiConfig.cwConfigTypesPath}`);
	if (conditions) url.searchParams.set("conditions", conditions);
	return url.toString();
}

// URL for creating a configuration
export function getCreateConfigUrl() {
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	return `${base}${apiConfig.cwConfigCreatePath}`;
}

// Build the URL for installation tickets for a given project id
export function getInstallationTicketsUrl(projectId) {
	if (!projectId) return "";
	const cond = `summary like "*Installation*" and project/id = ${projectId}`;
	return getProjectTicketsUrl(cond);
}

// Build URL to fetch finance agreements filtered by custom field (Quote #)
export function getAgreementsUrlByQuote(quoteNumber) {
    if (!quoteNumber) return "";
    const base = String(apiConfig.baseUrl).replace(/\/$/, "");
    const url = new URL(`${base}${apiConfig.cwFinanceAgreementsPath}`);
    url.searchParams.set("customFieldConditions", `value="${quoteNumber}"`);
    return url.toString();
}

// Build URL to attach a configuration to an agreement
export function getAttachAgreementUrl(agreementId) {
	if (!agreementId) return "";
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	return `${base}${apiConfig.cwAttachConfigAgreementPath}/${agreementId}`;
}

// Build URL for procurement products by project id
export function getProcurementProductsUrl(projectId) {
	if (!projectId) return "";
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	const url = new URL(`${base}${apiConfig.cwProcurementProductsPath}`);
	url.searchParams.set("conditions", `project/id=${projectId}`);
	return url.toString();
}

// Build URL to fetch scheduled resources (members) for an installation ticket id
export function getScheduledResourcesUrl(installationTicketId) {
	if (!installationTicketId) return "";
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	const url = new URL(`${base}${apiConfig.cwScheduledResourcesPath}`);
	url.searchParams.set("conditions", `objectid in (${installationTicketId})`);
	return url.toString();
}